import React from "react";
import MySpotlight from "containers/Spotlight/MySpotlight"
import "containers/Spotlight/MySpotlight.css";

class SpotlightHome extends React.Component {
  render() {
    return (
      <section >
          <MySpotlight/>
      </section>
    );
  }
}

export default SpotlightHome;